import React, { useMemo } from 'react'
import NonHydroProcessScreen from './NonHydroProcess'
import NonHydroEvents from './NonHydroEvents'
import { Route } from 'react-router-dom'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'

export const NonHydroContainer = ({ actionPermits, envConfig }) => {
  const eventHydro = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.NONHYDRO_VIEW,
          ScreenPermissions.NONHYDRO_ADD_DATA,
          ScreenPermissions.NONHYDRO_IMPORT,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const processHydro = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.NONHYDRO_PROCESS],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  return (
    <React.Fragment>
      {eventHydro && (
        <Route exact path="/nonhydro-events" component={NonHydroEvents} />
      )}
      {processHydro && (
        <Route
          exact
          path="/nonhydro-process"
          component={NonHydroProcessScreen}
        />
      )}
    </React.Fragment>
  )
}
